export default "__VITE_ASSET__DfdntIeu__"